module.exports = __webpack_public_path__ + "static/img/solutionValuePic03.bf0dc17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionValuePic03.png
// module id = ukq8
// module chunks = 0